(function () {
  function initTicker(root) {
    const slides = Array.from(root.querySelectorAll('[data-ticker-slide]'));
    if (!slides.length) return;

    const speed = (parseInt(root.dataset.speed, 10) || 4) * 1000;
    const autoRotate = root.dataset.autoplay !== 'false';
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    if (slides.length < 2 || !autoRotate) return;

    let timer = null;

    const show = (nextIndex) => {
      const current = slides[index];
      const next = slides[nextIndex];
      if (current === next) return;

      current.classList.remove('is-active');
      current.classList.add('is-exiting');
      next.classList.add('is-active');

      window.setTimeout(() => {
        current.classList.remove('is-exiting');
      }, 400);

      index = nextIndex;
    };

    const next = () => show((index + 1) % slides.length);

    const start = () => {
      stop();
      timer = window.setInterval(next, speed);
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
  }

  function initAll() {
    document.querySelectorAll('[data-announcement-ticker]').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-announcement-ticker]').forEach(initTicker);
  });
})();
